import { Card, Row } from "antd-v4";
import React from "react";

interface Props {
  icon?: any;
  titleIcon?: any;
  title?: string;
  subtitle?: string;
  chart?: React.ReactNode
}

export default function FullWidthCard(props: Props) {
  return (
    <Card className="hp-border-radius-xxl hp-dashboard-feature-card hp-cursor-pointer">
      {props.icon && (
        <div
          className="hp-d-flex-full-center hp-dashboard-feature-card-icon hp-border-radius-lg hp-bg-black-20 hp-bg-dark-80"
          style={{ width: 48, height: 48 }}
        >
          {props.icon}
        </div>
      )}
      <Row className="hp-d-flex hp-mt-12">
        {props.title && (
          <span className="h5 hp-text-uppercase hp-mb-0 hp-d-block hp-text-color-black-bg hp-text-color-dark-0 hp-font-weight-500 hp-mr-4">
            {props.title}
          </span>
        )}

        {props.titleIcon}
      </Row>

      {props.subtitle && (
        <span className="hp-caption hp-mt-4 hp-d-block hp-font-weight-400 hp-text-color-dark-0 hp-text-color-black-60">
          {props.subtitle}
        </span>
      )}

      {props.chart}
    </Card>
  );
}
